import { isMobileAppScheme, mobileAppUrlForScheme } from './appHandoffModel'

export type CheckoutOutcome = 'success' | 'cancel'
export type UpgradeHandoffOutcome = CheckoutOutcome | 'portal'

const checkoutOutcomes: CheckoutOutcome[] = ['success', 'cancel']
const upgradeHandoffOutcomes: UpgradeHandoffOutcome[] = [...checkoutOutcomes, 'portal']
const stripeSessionIdPrefix = /^cs_(live|test)_/

export const isUpgradeHandoffOutcome = (value: string): value is UpgradeHandoffOutcome =>
  upgradeHandoffOutcomes.some(outcome => outcome === value)

const carriesSessionId = (outcome: string): boolean => outcome !== 'portal'

export const upgradeAppUrl = (outcome: string, scheme: string, sessionId: string): string | null => {
  if (!isUpgradeHandoffOutcome(outcome) || !isMobileAppScheme(scheme)) {
    return null
  }
  if (!carriesSessionId(outcome)) {
    return mobileAppUrlForScheme(scheme, `upgrade/${outcome}`, {})
  }
  if (!sessionId) {
    return null
  }
  return mobileAppUrlForScheme(scheme, `upgrade/${outcome}`, { session_id: sessionId })
}

export const upgradeHandoffToken = (outcome: string, sessionId: string): string => {
  if (!carriesSessionId(outcome)) {
    return ''
  }
  return sessionId.replace(stripeSessionIdPrefix, '')
}
